<div>
  <div class="scrollx no-scroll">
    <div class="scroll-item mart10 marr10" *ngFor="let item of carouselList">
      <ion-card class="pad10 ion-no-margin" (click)="navigate(item)">
        <ion-card-header class="ion-no-padding">
          <ion-grid class="ion-no-margin ion-no-padding">
            <ion-row
              class="ion-justify-content-between ion-align-items-center padb10"
            >
              <ion-col size="auto" class="ion-no-padding">
                <ion-chip
                  class="grey-primary-chip border-r8 ion-no-margin"
                  mode="ios"
                  *ngIf="item?.logo || item?.displayName"
                >
                  <img src="{{ item?.logo }}" class="logo" />
                  <ion-label class="padl8 fs-2 font500">{{
                    item?.displayName
                  }}</ion-label>
                </ion-chip>
              </ion-col>
              <ion-col size="auto" class="ion-no-padding">
                <ion-label
                  class="card-primary-text-color fs-2 font500 padr5"
                  *ngIf="item?.type === 'upcomingFlight'; else otherService"
                >
                  <span class="fs-2 font500">
                    {{ item?.airlineName }}
                  </span>
                  - {{ item?.flightNo }}
                </ion-label>
                <ng-template #otherService>
                  <ion-label class="card-primary-text-color fs-2 font500 padr5"
                    >{{ item?.bookingDateTime || item?.pickupDateTime }}
                  </ion-label>
                </ng-template>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-header>
        <ion-card-content class="ion-no-padding card-content-container">
          <ion-list lines="none" class="ion-no-padding">
            <ion-item class="ion-no-padding ion-align-items-start">
              <ion-thumbnail
                slot="start"
                class="ion-no-margin marr10 service-img"
              >
                <ion-img
                  class="border-r8"
                  alt="Silhouette of mountains"
                  src="{{ item?.image ? item?.image : imagePlaceholder }}"
                  (ionError)="item.image = imagePlaceholder"
                />
              </ion-thumbnail>

              <ng-container
                *ngIf="item?.type === 'upcomingFlight'; else baggageInsurance"
              >
                <ion-grid class="ion-no-padding content">
                  <ion-row
                    class="w100 ion-justify-content-between ion-align-items-center"
                  >
                    <ion-col class="ion-no-padding" size="3">
                      <h2 class="fs-5 font700 card-primary-text-color">
                        {{ item?.src }}
                      </h2>
                      <div *ngIf="item?.originAirport?.scheduled_dep">
                        <p
                          class="{{
                            isExpectedActualDep(item?.originAirport)
                              ? 'strike'
                              : ''
                          }}"
                        >
                          {{ getTime(item?.originAirport?.scheduled_dep) }}
                        </p>
                        <p *ngIf="isExpectedActualDep(item?.originAirport)">
                          {{
                            getTime(isExpectedActualDep(item?.originAirport))
                          }}
                        </p>
                      </div>
                      <div *ngIf="!item?.originAirport?.scheduled_dep">
                        <p>
                          {{
                            getTime(item?.originAirport?.expected_dep) ||
                              getTime(item?.originAirport?.actual_dep) ||
                              "-"
                          }}
                        </p>
                      </div>
                    </ion-col>
                    <ion-col class="ion-no-padding ion-text-center" size="6">
                      <ion-label
                        class="fs-2 font600 ion-text-capitalize card-green-text-color"
                        *ngIf="
                          item?.status?.toLowerCase().trim() === 'on-time';
                          else delayed
                        "
                        >{{ item?.status }}</ion-label
                      >
                      <ng-template #delayed>
                        <ion-label
                          class="fs-2 font600 ion-text-capitalize card-yellow-text-color"
                          *ngIf="
                            item?.status?.toLowerCase().trim() === 'delayed';
                            else cancelled
                          "
                          >{{ item?.status }}</ion-label
                        >
                      </ng-template>
                      <ng-template #cancelled>
                        <ion-label
                          class="fs-2 font600 ion-text-capitalize card-red-text-color"
                          *ngIf="
                            item?.status?.toLowerCase().trim() === 'cancelled';
                            else otherStatus
                          "
                          >{{ item?.status }}</ion-label
                        >
                      </ng-template>
                      <ng-template #otherStatus>
                        <ion-label
                          class="fs-2 font600 ion-text-capitalize card-primary-text-color"
                          >{{ item?.status }}</ion-label
                        >
                      </ng-template>
                      <span class="flight-gif">
                        <img
                          src="/assets/icons/flight.gif"
                          class="font20"
                          alt="flight"
                        />
                      </span>
                      <p class="fs-2 font500 card-secondary-text-color">
                        {{
                          item?.duration ||
                            calculateTotalTime(
                              item?.originAirport?.expected_dep,
                              item?.destinationAirport?.expected_arr
                            )
                        }}
                      </p>
                    </ion-col>
                    <ion-col class="ion-no-padding ion-text-right" size="3">
                      <h2 class="fs-5 font700 card-primary-text-color">
                        {{ item?.dest }}
                      </h2>
                      <div *ngIf="item?.destinationAirport?.scheduled_arr">
                        <p
                          class="{{
                            isExpectedActualArr(item?.destinationAirport)
                              ? 'strike'
                              : ''
                          }}"
                        >
                          {{ getTime(item?.destinationAirport?.scheduled_arr) }}
                        </p>
                        <p
                          *ngIf="isExpectedActualArr(item?.destinationAirport)"
                        >
                          {{
                            getTime(
                              isExpectedActualArr(item?.destinationAirport)
                            ) || "-"
                          }}
                        </p>
                      </div>
                      <div *ngIf="!item?.destinationAirport?.scheduled_arr">
                        <p>
                          {{
                            getTime(item?.destinationAirport?.expected_arr) ||
                              getTime(item?.destinationAirport?.actual_arr) ||
                              "-"
                          }}
                        </p>
                      </div>
                    </ion-col>
                  </ion-row>
                  <div class="pad-top-5 dates">
                    <p class="fs-2 font500 ion-no-margin primary-text-color">
                      {{ formatDate(item?.originAirport?.scheduled_dep) }}
                    </p>

                    <p class="fs-2 font500 ion-no-margin primary-text-color">
                      {{ formatDate(item?.destinationAirport?.scheduled_arr) }}
                    </p>
                  </div>
                </ion-grid>
              </ng-container>

              <ng-template #baggageInsurance>
                <ng-container
                  *ngIf="item?.type === 'baggageInsurance'; else service"
                >
                  <ion-label class="ion-no-margin">
                    <div class="ion-no-padding">
                      <ion-grid fixed class="service-content ion-no-padding">
                        <ion-row
                          class="ion-padding-bottom ion-justify-content-between"
                        >
                          <ion-col size="5">
                            <p class="font11 ion-no-margin primary-text-color">
                              Flight Details
                            </p>
                            <span
                              class="fs-2 font500 line-2-clip text-wrap primary-text-color"
                              >{{ item?.flightNo }}</span
                            >
                          </ion-col>
                        </ion-row>
                        <ion-row class="ion-justify-content-between">
                          <ion-col size="6">
                            <p class="font11 ion-no-margin primary-text-color">
                              No of Bags
                            </p>
                            <span
                              class="fs-2 font500 line-2-clip text-wrap primary-text-color"
                              >{{ item?.noOfPax }}</span
                            >
                          </ion-col>
                        </ion-row>
                      </ion-grid>
                    </div>
                  </ion-label>
                </ng-container>
              </ng-template>

              <ng-template #service>
                <ion-label class="ion-no-margin">
                  <div class="">
                    <ion-grid fixed class="service-content ion-no-padding">
                      <ion-row
                        class="ion-padding-bottom ion-justify-content-between"
                      >
                        <ion-col
                          size="6"
                          class="ion-no-padding"
                          *ngIf="item?.airportName"
                        >
                          <p class="font11 ion-no-margin primary-text-color">
                            Airport
                          </p>
                          <span
                            class="fs-2 font500 line-2-clip text-wrap primary-text-color"
                            >{{ item?.airportName }}</span
                          >
                        </ion-col>
                        <ion-col size="5" *ngIf="item?.flightNo">
                          <p class="font11 ion-no-margin primary-text-color">
                            Flight Details
                          </p>
                          <span
                            class="fs-2 font500 line-2-clip text-wrap primary-text-color"
                            >{{ item?.flightNo }}</span
                          >
                        </ion-col>
                      </ion-row>
                      <ion-row class="ion-justify-content-between">
                        <ion-col size="6" *ngIf="item?.location">
                          <p class="font11 ion-no-margin primary-text-color">
                            Terminal
                          </p>
                          <span
                            class="fs-2 font500 line-2-clip text-wrap primary-text-color ion-text-capitalize"
                            >{{ item?.location }}</span
                          >
                        </ion-col>
                        <ion-col size="6" *ngIf="!item?.location && item?.bags">
                          <p class="font11 ion-no-margin primary-text-color">
                            Bags
                          </p>
                          <span
                            class="fs-2 font500 line-2-clip text-wrap primary-text-color ion-text-capitalize"
                            >{{ item?.bags }}</span
                          >
                        </ion-col>
                        <ion-col size="6" *ngIf="!item?.location && item?.serviceName">
                          <p class="font11 ion-no-margin primary-text-color">
                            Service Name
                          </p>
                          <span
                            class="fs-2 font500 line-2-clip text-wrap primary-text-color ion-text-capitalize"
                            >{{ item?.serviceName }}</span
                          >
                        </ion-col>
                        <ion-col size="6" *ngIf="item?.experienceTime">
                          <p class="font11 ion-no-margin primary-text-color">
                            Slot Time
                          </p>
                          <span
                            class="fs-2 font500 line-2-clip text-wrap primary-text-color ion-text-capitalize"
                            >{{ item?.experienceTime }}</span
                          >
                        </ion-col>
                        <ion-col
                          size="5"
                          *ngIf="
                            item?.type !== 'order' &&
                            item?.type !== 'baggageInsurance' &&
                            (item?.adult || item?.children || item?.infant)
                          "
                        >
                          <p class="font11 ion-no-margin primary-text-color">
                            Passenger
                          </p>
                          <span
                            class="fs-2 font500 line-2-clip text-wrap primary-text-color"
                          >
                            <span *ngIf="item?.adult">
                              {{ item?.adult }} Adults
                            </span>
                            <span *ngIf="item?.children">
                              , {{ item?.children }} Child
                            </span>
                            <span *ngIf="item?.infant">
                              , {{ item?.infant }} Infant
                            </span>
                          </span>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                  </div>
                </ion-label>
              </ng-template>
            </ion-item>
          </ion-list>
        </ion-card-content>
      </ion-card>
    </div>
  </div>
</div>
